import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createBlock as _createBlock, vModelSelect as _vModelSelect, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b3b9d93"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-stretch" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav nav-stretch nav-line-tabs fw-bold border-0",
    role: "tablist",
    id: "purchase_request_tab"
  }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link active",
        "data-bs-toggle": "tab",
        href: `#kt_Details`,
        role: "tab",
        "aria-selected": "true"
      }, "Details")
    ])
  ])
], -1))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = {
  class: "tab-pane fade active show",
  id: `kt_Details`,
  role: "tabpanel"
}
const _hoisted_8 = { class: "px-lg-2 pt-4 ribbon" }
const _hoisted_9 = {
  class: /*#__PURE__*/_normalizeClass(`ribbon-label`)
}
const _hoisted_10 = {
  key: 0,
  class: "py-5 px-lg-2 d-flex align-items-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Design Id", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_13 = { class: "ps-2 text-primary me-4" }
const _hoisted_14 = { class: "ms-auto" }
const _hoisted_15 = { class: "modal-body py-5 px-lg-2" }
const _hoisted_16 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_17 = { class: "row g-9 mb-7" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-6 fv-row"
}
const _hoisted_19 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_20 = {
  key: 1,
  class: "col-md-6 fv-row"
}
const _hoisted_21 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_22 = {
  key: 0,
  class: "el-form-item__content"
}
const _hoisted_23 = { class: "el-input el-input--default" }
const _hoisted_24 = ["onUpdate:modelValue", "type"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 2,
  class: "col-md-6 fv-row"
}
const _hoisted_27 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 3,
  class: "col-md-6 fv-row"
}
const _hoisted_30 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["value"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 4,
  class: "col-md-6 fv-row"
}
const _hoisted_35 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_36 = ["name", "onUpdate:modelValue"]
const _hoisted_37 = { class: "el-form-item__content" }
const _hoisted_38 = ["type", "onUpdate:modelValue", "onChange"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 3 }
const _hoisted_42 = {
  key: 5,
  class: "col-md-6 fv-row"
}
const _hoisted_43 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 6,
  class: "col-md-6 fv-row"
}
const _hoisted_46 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 7,
  class: "col-md-6 fv-row"
}
const _hoisted_50 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 8,
  class: "col-md-12 fv-row"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-5" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 9,
  class: "col-md-12"
}
const _hoisted_56 = {
  key: 10,
  class: "col-md-12 fv-row"
}
const _hoisted_57 = {
  key: 0,
  class: ""
}
const _hoisted_58 = { class: "mb-3 fs-2hx" }
const _hoisted_59 = { class: "fw-bold" }
const _hoisted_60 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_61 = { class: "w-100 d-flex flex-center" }
const _hoisted_62 = ["data-kt-indicator"]
const _hoisted_63 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_65 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_66 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaterialMultiselect = _resolveComponent("MaterialMultiselect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_FeeListing = _resolveComponent("FeeListing")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBack && _ctx.onClickBack(...args)))
      }, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.selectedTab == 'Details')
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  class: "card card-bordered",
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
                  model: _ctx.formData,
                  rules: _ctx.rules,
                  ref: "formRef"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formData.material_type), 1)
                    ]),
                    (!_ctx.isAdd)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          _hoisted_12,
                          _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.formData.id), 1),
                          _createElementVNode("div", _hoisted_14, [
                            (!_ctx.isEdit)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-primary ms-2",
                                  type: "button",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setEdit(true)))
                                }, " Edit "))
                              : _createCommentVNode("", true),
                            (_ctx.isEdit)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-primary ms-2",
                                  type: "button",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setEdit(false)))
                                }, " Cancel "))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                        {
                          name: 'material_id',
                          label: 'Material',
                          type: 'materialMultiselect',
                          options: [],
                        },
                        {
                          name: 'width',
                          label: 'Width',
                          type: 'text',
                        },
                        {
                          name: 'height',
                          label: 'Height',
                          type: 'text',
                        },
                        {
                          name: 'cuttingTime',
                          label: 'Cutting Time',
                          type: 'text',
                        },
                        {
                          name: 'cuttingCost',
                          label: 'Cutting Cost',
                          type: 'text',
                        },
                      ], (formItem) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: formItem.name
                            }, [
                              (formItem.type == 'materialMultiselect')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("label", _hoisted_19, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_MaterialMultiselect, {
                                          isEdit: _ctx.isEdit,
                                          class: "form-select rounded-3",
                                          modelValue: _ctx.formData[formItem.name],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event),
                                          selectedValue: _ctx.formData.material_data
                                        }, null, 8, ["isEdit", "modelValue", "onUpdate:modelValue", "selectedValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (['color'].indexOf(formItem.type) != -1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("label", _hoisted_21, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isEdit)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              _createElementVNode("div", _hoisted_23, [
                                                _withDirectives(_createElementVNode("input", {
                                                  class: "el-input__inner",
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event),
                                                  type: formItem.type,
                                                  autocomplete: "off",
                                                  placeholder: ""
                                                }, null, 8, _hoisted_24), [
                                                  [_vModelDynamic, _ctx.formData[formItem.name]]
                                                ])
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.formData[formItem.name]), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (['text', 'number'].indexOf(formItem.type) != -1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("label", _hoisted_27, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isEdit)
                                          ? (_openBlock(), _createBlock(_component_el_input, {
                                              key: 0,
                                              modelValue: _ctx.formData[formItem.name],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event),
                                              type: formItem.type,
                                              placeholder: ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "type"]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.formData[formItem.name]), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'select')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("label", _hoisted_30, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isEdit)
                                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                              key: 0,
                                              class: "form-select rounded-3",
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.options, (opt) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: opt.id,
                                                  value: opt.id
                                                }, _toDisplayString(opt.label), 9, _hoisted_32))
                                              }), 128))
                                            ], 8, _hoisted_31)), [
                                              [_vModelSelect, _ctx.formData[formItem.name]]
                                            ])
                                          : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.formData[formItem.name]), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'multi-text')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("label", _hoisted_35, _toDisplayString(formItem.label), 1),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "hidden",
                                      name: formItem.name,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                    }, null, 8, _hoisted_36), [
                                      [_vModelText, _ctx.formData[formItem.name]]
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multiForm[
                              formItem.name
                            ], (item, itemIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "el-input el-input--default d-flex align-items-center",
                                          key: itemIndex
                                        }, [
                                          (_ctx.isEdit)
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                class: "el-input__inner",
                                                type: formItem.multiType,
                                                autocomplete: "off",
                                                placeholder: "",
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.multiForm[formItem.name][itemIndex]) = $event),
                                                onChange: ($event: any) => (
                                _ctx.formData[formItem.name] =
                                  _ctx.multiForm[formItem.name].join(',')
                              )
                                              }, null, 40, _hoisted_38)), [
                                                [_vModelDynamic, _ctx.multiForm[formItem.name][itemIndex]]
                                              ])
                                            : _createCommentVNode("", true),
                                          (itemIndex != 0 && _ctx.isEdit)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "btn btn-danger",
                                                type: "button",
                                                onClick: ($event: any) => (
                                _ctx.multiForm[formItem.name].splice(itemIndex, 1)
                              )
                                              }, " x ", 8, _hoisted_39))
                                            : _createCommentVNode("", true),
                                          (itemIndex == 0 && _ctx.isEdit)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "btn btn-success",
                                                type: "button",
                                                onClick: ($event: any) => (_ctx.multiForm[formItem.name].push(''))
                                              }, " + ", 8, _hoisted_40))
                                            : _createCommentVNode("", true),
                                          (!_ctx.isEdit)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(item), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'date')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("label", _hoisted_43, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.formData[formItem.name] && _ctx.isEdit)
                                          ? (_openBlock(), _createBlock(_component_datepicker, {
                                              key: 0,
                                              class: "form-control rounded-3",
                                              modelValue: _ctx.formData[formItem.name],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.moment(_ctx.formData[formItem.name]).format("LLL")), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'textarea')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _createElementVNode("label", _hoisted_46, _toDisplayString(formItem.label), 1),
                                    (formItem.type == 'textarea')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          prop: formItem.name
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.isEdit)
                                              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                  key: 0,
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event),
                                                  class: "form-control rounded-3",
                                                  rows: "4"
                                                }, null, 8, _hoisted_47)), [
                                                  [_vModelText, _ctx.formData[formItem.name]]
                                                ])
                                              : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.formData[formItem.name]), 1))
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'button' && _ctx.isEdit)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    _createElementVNode("label", _hoisted_50, _toDisplayString(formItem.label), 1),
                                    (formItem.type == 'button')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          prop: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-info",
                                              onClick: formItem.clickEvent
                                            }, _toDisplayString(formItem.label), 9, _hoisted_51)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'separator')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                                : _createCommentVNode("", true),
                              (formItem.type == 'blank')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55))
                                : _createCommentVNode("", true),
                              (formItem.type == 'title')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    (formItem.type == 'title')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, _toDisplayString(formItem.label), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 64))
                        ])
                      ])
                    ]),
                    (_ctx.isEdit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("button", {
                              "data-kt-indicator": _ctx.loading ? 'on' : null,
                              class: "btn btn-lg btn-primary",
                              type: "submit"
                            }, [
                              (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                                    _hoisted_64,
                                    _createElementVNode("span", _hoisted_65, [
                                      _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, _hoisted_69))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_62)
                          ]),
                          _hoisted_70
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["model", "rules"]))
              : _createCommentVNode("", true),
            (!_ctx.isAdd && !_ctx.isEdit)
              ? (_openBlock(), _createBlock(_component_FeeListing, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}